import { graphql, StaticQuery } from 'gatsby';
import GoogleMapReact from 'google-map-react';
import React from 'react';

import { queryResponse } from '../../../interfaces/AllKindergartensQueryResponse';
import { Marker } from './Marker';

const mapProps = {
  center: {
    lat: 52.0905,
    lng: 21.005235,
  },
  zoom: 14.0,
};

interface MapProps {
  location: {
    pathname: string;
  };
}

interface Kindergarten {
  geographicalCoordinates: {
    latitude: number;
    longitude: number;
  };
  email: string;
  address: string;
  secondPhone: string;
  firstPhone: string;
  name: string;
}

const query = graphql`
  query {
    allKindergartensJson {
      nodes {
        geographicalCoordinates {
          latitude
          longitude
        }
        email
        address
        secondPhone
        firstPhone
        name
      }
    }
  }
`;

export const Map = ({ location }: MapProps) => {
  return (
    <StaticQuery
      query={query}
      render={(data: queryResponse<Kindergarten>) => {
        return (
          <div style={{ height: '400px', width: '100%' }}>
            <GoogleMapReact
              bootstrapURLKeys={{ key: 'AIzaSyBxyB5Jv4m-N1BcRCOsfxmI67vnTGbL7Y4' }}
              defaultCenter={mapProps.center}
              defaultZoom={mapProps.zoom}
              options={{ disableDefaultUI: true }}
            >
              {data.allKindergartensJson.nodes.map((kindergarten) => {
                return (
                  <Marker
                    key={kindergarten.name}
                    node={kindergarten}
                    lat={kindergarten.geographicalCoordinates.latitude}
                    lng={kindergarten.geographicalCoordinates.longitude}
                    location={location}
                  />
                );
              })}
            </GoogleMapReact>
          </div>
        );
      }}
    />
  );
};
